import JoinRoute from '@/screens/Join/JoinRoute';

export default function OrganizationJoinRoute() {
  return <JoinRoute kind="organization" />;
}
